<template>
  <b-form-group v-if="roles && roles.length > 0" :id="`${roleType}List`" :label="formattedFormLabel">
    <div class="row scroll scroll-md">
      <div class="col-12">
        <b-form-checkbox-group stacked :id="`chk-grp-current-${roleKind}-${roleType}`"
                               :name="`current_${roleKind}_${roleType}`"
                               v-model="formArray">
          <b-form-checkbox v-for="role in roles"
                           :key="`${role.roleId}_${role.kind}`"
                           :value="{roleId: role.roleId, kind: role.kind}"
                           :id="`chk-${role.kind}-${roleType}-${role.roleId}`">
            <display-role :role="role" :role-type="roleType" :with-link="false" />
          </b-form-checkbox>
        </b-form-checkbox-group>
      </div>
    </div>
  </b-form-group>
</template>

<script>
import { util } from '../../util/groups-mixin';
import DisplayRole from '../DisplayRole';

export default {
  name: 'RemoveRolesFormGroup',
  mixins: [util],
  components: {
    DisplayRole,
  },
  props: {
    /* The list of roles that will be presented for removal. E.g. The list of current group admins */
    roles: {
      type: Array,
      required: true,
    },
    /* The array that will hold the roles that are selected for removal. */
    formArray: {
      type: Array,
      required: true,
    },
    /* The type of role represented. One of [administrators, managers, contacts, viewers] */
    roleType: {
      type: String,
      required: true,
    },
    /* Provide a custom id attribute for the form-group. Use if testing requires/expects a specific value */
    formGroupId: {
      type: String,
      required: false,
    },
    /* Provide a custom label for this group. */
    formLabel: {
      type: String,
      required: false,
    },
  },
  computed: {
    formattedFormLabel() {
      if (this.formLabel && !this.isEmpty(this.formLabel)) {
        return this.formLabel;
      }
      return `Remove ${this.capitalize(this.roleKind)} ${this.capitalize(this.roleType)}`;
    },
    roleKind() {
      if (this.roles.length > 0) {
        return this.roles[0].kind;
      }
      return '';
    },
  },
  watch: {
    formArray() {
      this.$emit('update:formArray', this.formArray);
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/form/RemoveRolesFormGroup.vue